import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as selectors from '../toast.selectors'
import * as gameSelectors from '../../../Core/Game/game.selectors'

import { FormattedMessage } from 'react-intl'

/**
 *  Toast Component.
 */

const BasicToast = ({ toastProps, position }) => {
  if (!toastProps) {
    return null
  }
  const { style, label, icon, cursorPosition, customClass } = toastProps

  let st = {
    ...style,
    position: cursorPosition ? 'absolute' : null,
    top: cursorPosition ? position.y : null,
    left: cursorPosition ? position.x : null,
  }

  return (
    <div className={customClass} style={st}>
      <span className={icon}> </span>
      {label ? <FormattedMessage id={label} /> : null}
    </div>
  )
}

const mapStateToProps = (state) => ({
  toastProps: selectors.getToastProps(state),
  position: gameSelectors.getCursorPosition(state),
})

BasicToast.propTypes = {
  toastProps: PropTypes.object,
  position: PropTypes.object,
}

export default connect(mapStateToProps)(BasicToast)
